import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from 'ionic-angular';
import { CalendarModal } from 'ion2-calendar';
import * as moment from 'moment';
import { MeteorObservable } from 'meteor-rxjs';
import { conformToMask } from 'angular2-text-mask';
import * as _ from 'lodash';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import { Project, User } from 'api/models';
// import { getProject, getProjectManagers } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
// import { getCompany } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
import { EditProjectInfoComponent } from '../edit-project-info/edit-project-info';
import * as permissions from '../../services/permissions';
import { ISDEV } from "../../services/config";
import { AuthenticationService } from '../../services/congito';
import { HttpService } from '../../services/httpService';

@Component({
  selector: 'project-info',
  templateUrl: 'project-info.html'
})
export class ProjectInfo implements OnInit {
  project?: Project | void;
  pmUsers?: User[];
  canUpdateNTP: boolean;
  canUpdateCCD: boolean;
  canEditSiteLocation: boolean;
  dollarMask: { mask: (str: string) => Array<string|RegExp> };
  public isDev = ISDEV;

  constructor(
    private modalCtrl: ModalController,
    public navParams: NavParams,
    public companyService: CompanyService,
    public projectService: ProjectService,
    public authenticationService: AuthenticationService,
    public httpService: HttpService
  ) {
    this.dollarMask = {
      mask: createNumberMask({
        prefix: '$',
        includeThousandsSeparator: true,
        allowDecimal: true,
        decimalLimit: 2,
        integerLimit: null, // unlimited
        requireDecimal: false,
      }),
    };
  }

  ngOnInit(): void {
 if(this.isDev == true) {  console.log('project info page') }
    const { projectId } = this.navParams.data;
    MeteorObservable.autorun().subscribe(() => {
      const projectIdReactive = this.navParams.get('projectIdReactive');
      const projectId =  projectIdReactive && projectIdReactive.get();
      this.project = this.projectService.getProject(projectId);
      this.pmUsers = this.projectService.getProjectManagers(this.project);
      this.updatePermissionParams();
    });
  }

  updatePermissionParams() {
    const viewer = this.authenticationService.MeteorUser();
    const company = this.project ? this.companyService.getCompany(this.project.companyId) : null;
    const isProjectManager = this.project ? permissions.isProjectManager(this.project, viewer) : false;
    const isCompanyAdmin = permissions.isCompanyAdmin(company, viewer);
    const isSuperAdmin = permissions.isSuperAdmin(viewer);
    this.canUpdateNTP = isProjectManager || isCompanyAdmin || isSuperAdmin;
    this.canUpdateCCD = isProjectManager || isCompanyAdmin || isSuperAdmin;
    this.canEditSiteLocation = isProjectManager || isCompanyAdmin || isSuperAdmin;
  }

  formatPhoneNumber(phoneNumberStr: void|string): string {
    const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return conformToMask(phoneNumberStr || '', phoneMask, {guide:false}).conformedValue;
  }

  formatDollar(dollarStr: void|string): string {
    return conformToMask(dollarStr || '', this.dollarMask.mask(dollarStr || ''), {guide:false}).conformedValue;
  }

  goToEditProjectInfo(): void {
    if (!this.project) {
      return;
    }
    const modal = this.modalCtrl.create(EditProjectInfoComponent, {projectId: this.project._id}, {enableBackdropDismiss: false});
    modal.present();
  }

  presentCCDModal(): void {
    if (!this.project) {
      return;
    }
    const myCalendar = this.modalCtrl.create(CalendarModal, {
      options: {
        title: 'Contract Completion',
        pickMode: 'single',
        from: new Date(moment(this.project.ntpDate).add(24, 'hours').toDate().getTime()),
      },
    });

    myCalendar.onDidDismiss((date, type) => {
      if (type === 'cancel') {
        return;
      }

      if (!this.project) {
        return;
      }
      const contractCompletionDate = date ? new Date(date.time) : undefined;
      this.httpService.MeteorCall('updateProject', this.project._id, { contractCompletionDate });
    });

    myCalendar.present();
  }

  presentNTPModal(): void {
    if (!this.project) {
      return;
    }
    const myCalendar = this.modalCtrl.create(CalendarModal, {
      options: {
        title: 'Notice To Proceed',
        pickMode: 'single',
        from: new Date(moment(this.project.ntpDate).add(24, 'hours').toDate().getTime()),
      },
    });

    myCalendar.onDidDismiss((date, type) => {
      if (type === 'cancel') {
        return;
      }

      if (!this.project) {
        return;
      }
      const ntpDate = date ? new Date(date.time) : undefined;
      this.httpService.MeteorCall('updateProject', this.project._id, { ntpDate });
    });

    myCalendar.present();
  }

  updateProjectLocation(): void {
    if (!this.project) {
      return;
    }
    const locationChanges = _.pick(this.project, ['siteAddress', 'cityTown', 'state', 'zipCode', 'country', 'trailerPhone']);
    this.httpService.MeteorCall('updateProject', this.project._id, { ...locationChanges });
  }
}



// WEBPACK FOOTER //
// ./src/pages/project-info/project-info.ts